module.exports = __webpack_public_path__ + "img/pg-icon.d339eff8.svg";